import { Dialog, DialogContent } from "@radix-ui/themes";
import { userInfoMapperSocket } from "components/containers/utils/sockets/userInfoMapperSocket";
import { User } from "models/User";
import { useEffect, useRef, useState,useContext } from "react";
import { useSelector } from "react-redux";
import { validateAndCreateSocketIfExist } from "utils/SocketValidator";
import XCircle from "../../../../assets/images/XCircle.png";
import BadgesSuccessModal from "./BadgeSuccessModal";
import SocketContext from "socket-context";
import { UserInfoMapperSocketHandler } from "utils/UserInfoMapper";

export default function ShareBadgesModal({
  visible,
  onRequestClose,
  onPressBack,
  shareBadgesItem
}: any) {
  const sessionData = useSelector((state: any) => state?.live.settings?.sessionData);
  const participants = useSelector((state: any) => state?.live.settings?.batch?.participants);
  const profileData = useSelector((state: any) => state?.auth?.user as User);
  const consumers = useSelector((state: any) => state?.live.settings?.consumers);
  const batchData = useSelector((state: any) => state?.live.settings?.batch);
  const participantsData = useSelector((state: any) => state?.live.settings?.participants);

  let userInfoHandler = new UserInfoMapperSocketHandler();
  // @ts-ignore
  const socketList: socketContextType[] = useContext(SocketContext);

  const [p, setP] = useState([]);
  const [updateP, setUpdateP] = useState([])
  const [showModal, setShowModal] = useState(false);
  const [message, setMessage] = useState('');
  const [checkBoxVal, setCheckBoxVal] = useState([]);
  const [currentActiveIndex, setCurrentActiveIndex] = useState(0)
  const flatRef = useRef<any>(null);
  const session_id = useSelector((state: any) => state?.session?.sessionData?.id);


  useEffect(() => {
    setCheckBoxVal([])
  }, [shareBadgesItem]);

  const sendBadges = () => {
    if (checkBoxVal?.length < 1) {
      return;
    }
    saveSendedBadged();
    let objUserReactionData = {
      reaction_type: shareBadgesItem?.name,
      reaction_sub_type: shareBadgesItem?.name,
      reacted_by: profileData?.name,
      reacted_by_type: 'trainee',
      sent_to: checkBoxVal,
    };
    userInfoHandler = validateAndCreateSocketIfExist(session_id, () => { }, socketList);
    userInfoHandler.sendMessage(
      JSON.stringify({
        type: 'show_badges',
        sub_type: 'badge_share_count',
        user_badge_data: objUserReactionData,
        room_id: sessionData?.id
      }),
    );
  };

  const saveSendedBadged = async () => {
    let userData = profileData;
    let senderId = userData.id
    let data = {
      "achievementName": shareBadgesItem?.name,
      "sessionId": sessionData?.id,
      "programId": sessionData?.session?.program?.id,
      "receiverEmail": checkBoxVal,
      "senderId": senderId,
      "senderName": profileData?.name
    };
    // postDataWithToken(data, mobile_siteConfig.SAVE_BADGES)
    //   .then((res) => {
    //     console.log("save badges res -->", res)
    //     if (res?.code == 200) {
    //       setMessage(res?.message);
    //       setShowModal(true);
    //       setCheckBoxVal([]);
    //     }
    //   })
    //   .catch(error => {
    //     console.log('save badges error -->', error);
    //   });
    // update session meta info 
    let _trainee_list: any = []
    batchData?.participants?.forEach((e: any) => {
      if (checkBoxVal?.includes(e?.email)) {
        _trainee_list.push(e?.id)
      }
      else {
        return
      }
    })
    let objBody = {
      sessionSegmanetId: session_id,
      type: shareBadgesItem?.name,
      traineeList: _trainee_list?.toString()
    };
    // postDataWithToken(objBody, mobile_siteConfig.MOB_UPDATE_SESSION_META_INFO)
    //   .then((res: any) => {
    //     const { response } = res;
    //     if (response.data && typeof response.data == 'object') { } else { }
    //   })
    //   .catch((error: any) => { console.log(error) });
  }

  const chunk = (arr: any[], n: number): any[][] => {
    const result = [];
    for (let i = 0; i < arr?.length; i += n) {
      result.push(arr.slice(i, i + n));
    }
    return result;
  };


  const getJoinCount = async (peerData: any) => {
    var peerDatax = peerData;
    let _allJoinee = participantsData?.filter((x: any) => x?.userEmail != profileData?.email)

    var filtered_allJoinee = _allJoinee.filter((_allJoineeObj: any) => {
      var matchingpeerDatax = peerDatax.flat().find((peerDataxObj: any) => peerDataxObj.peerId === _allJoineeObj.userEmail);
      if (matchingpeerDatax) {
        return true;
      } else if (_allJoineeObj.role === 'trainer') {
        return true;
      }
      return false;
    });
    setP(filtered_allJoinee)
    setUpdateP(filtered_allJoinee)
  }

  const CheckBox = (item) => {
    const newCheckBoxVal = checkBoxVal.includes(item?.userEmail)
      ? checkBoxVal.filter((email) => email !== item?.userEmail)
      : [...checkBoxVal, item?.userEmail];
    setCheckBoxVal(newCheckBoxVal);
  };
  return (
    <div className="overflow-y-auto">
      <Dialog.Root open={visible && !showModal} onOpenChange={onRequestClose}>
        <Dialog.Content className="flex justify-end h-[50%] bg-white rounded-t-[30px] w-full max-w-full">
          <div className="bg-[#E9BE50] w-full h-[15%] -mt-[12px] rounded-t-[26px] flex flex-row items-center">
            <span
              className="text-[#212025] text-lg pl-[10px]"
              style={{ fontFamily: "'Lato', sans-serif", fontWeight: '600' }}
            >
              Share {shareBadgesItem?.name} Badge with -
            </span>
            <button onClick={onPressBack} className="ml-[50px] mt-[15px]">
              <img
                src={XCircle}
                alt="Close"
                className="object-contain"
                style={{ height: '4%', width: '10%', filter: 'hue-rotate(270deg) saturate(150%) brightness(80%)' }}
              />
            </button>
          </div>
          <div className="flex flex-row justify-around flex-1 my-[1%]">
            <div className="w-full">
              <div ref={flatRef} className="w-full overflow-x-auto flex" style={{ scrollSnapType: 'x mandatory' }}>
                {[...chunk(p, 4)].map((item, index) => (
                  <div
                    key={index}
                    className="w-full flex-shrink-0"
                    style={{ scrollSnapAlign: 'start', width: '100%' }}
                  >
                    {item?.map((v) => (
                      <div key={v.userEmail} className="flex flex-row items-center mb-[1%]">
                        <span
                          className="text-black text-base font-bold ml-[50px]"
                          style={{ fontFamily: "'Lato', sans-serif" }}
                        >
                          {`${v?.userName} ${v?.role === 'trainer' ? '(Trainer)' : ''}`}
                        </span>
                        <div className="flex-1 flex justify-end -ml-[100px]">
                          <button
                            onClick={() => CheckBox(v)}
                            className={`bg-${checkBoxVal?.includes(v?.userEmail) ? '[#5F488A]' : '[#F0F0F0]'
                              } rounded-[1%] mr-[4%] h-[8%] w-[8%] flex items-center justify-center`}
                          >
                            {checkBoxVal?.includes(v?.userEmail) && (
                              <img
                                src="/assets/TickWhite.png"
                                alt="Check"
                                className="object-contain"
                                style={{ height: '4%', width: '4%' }}
                              />
                            )}
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="border-b border-black" />
          <button
            className="bg-[#5F488A] text-white mx-auto my-[3%] py-[0.7%] px-[6%] rounded-[1%]"
            onClick={() => {
              onRequestClose();
              sendBadges();
            }}
          >
            <span className="text-white text-xl font-bold" style={{ fontFamily: "'Lato', sans-serif" }}>
              Share
            </span>
          </button>
        </Dialog.Content>
      </Dialog.Root>
      <BadgesSuccessModal
        message={message}
        visible={showModal}
        onRequestClose={() => setShowModal(false)}
        onPress={() => {
          setShowModal(false);
        }}
      />
    </div>
  )
}